export default function AppBar({ children }) {
  return children;
}

AppBar.type = Symbol('PageWithStaticHeader.AppBar');
